var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.show)?_c('div',{ref:"overlay",staticClass:"sliding-card-overlay"},[_c('div',{style:(_vm.wrapperStyle)},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }